/** @jsxImportSource @emotion/react */
import { FC } from 'react';
import * as styles from './AISuggestionButtons.styles';
import { Constants } from 'global';

interface AISuggestionButtonsProps {
  suggestions: string[];
  onSelect: (value: string) => void;
}

export const AISuggestionButtons: FC<AISuggestionButtonsProps> = ({
  suggestions,
  onSelect,
}) => {
  if (!suggestions || suggestions.length === 0) {
    return null;
  }

  return (
    <div css={styles.suggestionContainer}>
      <div css={styles.suggestionHeader}>
        <img
          src={Constants.assets.signUpAssets.icons.aiSuggestionSmallSparkle}
          alt="AI suggestion"
          width="16"
          height="16"
        />
        <p className="body4" css={styles.suggestionLabel}>
          Suggestion
        </p>
      </div>
      {suggestions.map((suggestion, index) => (
        <div
          key={index}
          className="body4"
          css={styles.suggestionButton}
          onClick={() => onSelect(suggestion)}
          title={suggestion}
        >
          <span css={styles.suggestionText}>{suggestion}</span>
        </div>
      ))}
    </div>
  );
};
